import Vue from 'vue'
import MySiderLayout from './Sider/MySiderLayout.vue';
import MyBread from './Breadcrumb/MyBreadcrumb.vue';
import MyPage from './page/Page.vue';
import TimeSelect from './TimeSelect/TimeSelect.vue';
  // 全局注册组件
Vue.component('MySiderLayout', MySiderLayout);
Vue.component('MyBread', MyBread);
Vue.component('MyPage', MyPage);
Vue.component('TimeSelect', TimeSelect);
export default{};

